import React from "react";
import PropTypes from "prop-types";

const PromoBlockSection = ({section}) => {
  let { content, colour, bgColour, topMargin, bottomMargin, heading } = section;
  let blockCount = content.items.length;

  return (
    <div className={`wrapper block-wrapper bg-${bgColour} ${topMargin} ${bottomMargin}`}>
      <div className="wrapper--inner flex flex-w-w flex-jc-sb">
        {heading && <h2 className={`col-1 color-${colour} ff-s h2 block-heading mt-0`} dangerouslySetInnerHTML={{__html: heading}}></h2>}
        {content.items.map((item) => {
          let content = item.content;
          return (
            <div 
              key={item.id}
              className={`ta-left col-1 col-md-2-1 col-lg-${blockCount}-1 bg-${colour} cta-block promo-block flex justify-space direction-column ta-left`}
            >
              <div className="cta-block-content">
                <a href={content.url}>
                  <img className="w-100" alt={content.image_alt} src={content.image} srcSet={content.image_srcset} />
                </a>
                <h3 className={`ff-s h2  color-${colour}`} dangerouslySetInnerHTML={{__html: content.heading}}></h3>
                <div dangerouslySetInnerHTML={{__html: content.content}}></div>
              </div>
              <a href={content.url} className={`btn-m-m btn-m-m-full btn-${colour} dib-m`}>{content.button}</a>
            </div>
          );
        })}
      </div>
    </div>
  );
}

PromoBlockSection.propTypes = {
  section: PropTypes.object.isRequired
}

export default PromoBlockSection;
